import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Chart } from 'chart.js';
import { IBusinessSectorStatistic } from 'src/app/reports/reports-models';
import { newId } from 'src/app/shared/utilities';
import { UtilsService } from 'src/app/shared/utils.service';

@Component({
  selector: 'app-business-sectors',
  templateUrl: './business-sectors.component.html',
  styleUrls: ['../charts.scss', './business-sectors.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule]
})
export class BusinessSectorsComponent implements OnInit, OnChanges, AfterViewInit {

  constructor(
    private utilsService: UtilsService,
    private translateService: TranslateService) {
  }

  @Input()
  data: IBusinessSectorStatistic[];
  @Input()
  textColor: string;
  @Input()
  fontOptions: any;
  legend: string[];

  private readonly _canvasId = `businessSectorCanvas${newId()}`;
  get canvasId() { return this._canvasId; }
  barColor = this.utilsService.readCssStyleProperty('--clr-svea-2');

  graph: any = {
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: this.barColor,
        borderColor: this.barColor,
        borderWidth: 1,
      }
    ]
  };

  options: any;

  barChartCanvas: HTMLCanvasElement;
  barChart;

  ngOnInit(): void {
   this.legend = this.data.map(x => `${x.code} - ${x.name}`);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data && changes.data.previousValue) {
      this.barChart.destroy();
      this.buildChart();
    }
  }

  ngAfterViewInit(): void {
    this.barChartCanvas = document.getElementById(this.canvasId) as HTMLCanvasElement;
    this.buildChart();
  }

  private buildChart() {
    this.options = {
      plugins: {
        legend: {
          labels: {
            color: this.textColor,
            font: this.fontOptions
          }
        }
      },
      responsive: true,
      maintainAspectRatio: false,
      clamp: true
    }

    const labels = this.data.map(x => x.code);
    const graphData = this.data.map(x => x.numberOfCases);

    this.graph.labels = labels;
    this.graph.datasets[0].data = graphData;
    this.graph.datasets[0].label = this.translateService.instant('Reports.PortfolioReport.NumberOfCases');

    this.barChart = new Chart(this.barChartCanvas, {
      type: 'bar',
      data: this.graph,
      options: this.options
    });
  }
}
